import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './TopFest.scss';

const topFestivals = [
  {
    id: 1,
    name: 'Diwali',
    img: 'https://www.drikpanchang.com/images/events/diwali/lakshmipuja/xdiwali_celebration.jpg.pagespeed.ic.CKvFnHrYti.jpg',
    description: 'Diwali is the Hindu festival of lights, symbolizing the victory of light over darkness and good over evil.'
  },
  {
    id: 2,
    name: 'Holi',
    img: 'https://www.thepalaceonwheels.org/storage/Holi-Delhi.jpeg',
    description: 'Holi is the festival of colors celebrated with joy, signifying the arrival of spring and the triumph of good over evil.'
  },
  {
    id: 3,
    name: 'Navratri',
    img: 'https://giriaus.com/cdn/shop/articles/navaratriblog_1200x600_crop_center.jpg?v=1727150363',
    description: 'Navratri is a nine-night festival dedicated to Goddess Durga and her various forms, celebrated with dance and devotion.'
  },
  {
    id: 4,
    name: 'Durga Puja',
    img: 'https://akm-img-a-in.tosshub.com/indiatoday/images/story/202210/tanuj-adhikary-B3Knp6y8q4M-uns_1_x.jpeg?VersionId=XN0YMKHd_UOXTf3WTTlh.bzk6h9LykPP',
    description: 'Durga Puja honors the victory of Goddess Durga over Mahishasura and is celebrated with grand rituals and artistic displays.'
  },
  {
    id: 5,
    name: 'Raksha Bandhan',
    img: 'https://images.moneycontrol.com/static-mcnews/2024/08/20240808074846_Daily-Horoscope-6.png',
    description: 'Raksha Bandhan celebrates the bond between brothers and sisters, symbolized by tying a sacred thread (rakhi).'
  },
  {
    id: 6,
    name: 'Janmashtami',
    img: 'https://im.indiatimes.in/content/2024/Aug/New-Project-1_66c4bdf69365b.jpg?w=1200&h=900&cc=1&webp=1&q=75',
    description: 'Janmashtami marks the birth of Lord Krishna, celebrated with fasting, devotional songs, and dramatic enactments.'
  },
  {
    id: 7,
    name: 'Ganesh Chaturthi',
    img: 'https://akm-img-a-in.tosshub.com/indiatoday/images/media_bank/202309/ganesh-chaturthi-2023-wishes-to-celebrate-the-divine-festival-182626678-1x1.jpg',
    description: 'Ganesh Chaturthi is the birthday of Lord Ganesha, celebrated by installing idols and offering prayers.'
  },
  {
    id: 8,
    name: 'Makar Sankranti',
    img: 'https://images.moneycontrol.com/static-mcnews/2025/01/20250112190239_makar.png?impolicy=website&width=770&height=431',
    description: 'Makar Sankranti is a harvest festival celebrated when the Sun enters Capricorn, marked by kite flying and sweets.'
  },
  {
    id: 9,
    name: 'Mahashivratri',
    img: 'https://www.savaari.com/blog/wp-content/uploads/2023/01/parvati-yearns-for-and-fervently-prays-to-lord-shiva-illustration-md_11zon.jpg',
    description: 'Mahashivratri is dedicated to Lord Shiva, observed with fasting and night-long vigil and chants.'
  },
  {
    id: 10,
    name: 'Ram Navami',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRVY63kgYRroZDI_-huXzE_7x6ekeKWSE4bIg&s',
    description: 'Ram Navami marks the birth of Lord Rama and is celebrated with religious processions and readings from the Ramayana.'
  }
];

const TopFest = () => {
  const [selectedFest, setSelectedFest] = useState(null);

  const handleCardClick = (fest) => {
    setSelectedFest(fest);
  };

  const handleClosePopup = () => {
    setSelectedFest(null);
  };

  return (
    <div className="topfest-container">
      <InnerNav />
      <div className="topfest-content">
        <Zodiac />

        <div className="festival-header">
          <h4>Top 10 Most Celebrated Hindu Festivals</h4>
        </div>

        <div className="festival-grid">
          {topFestivals.map((fest) => (
            <div className="festival-card" key={fest.id} onClick={() => handleCardClick(fest)}>
              <img
                src={fest.img}
                alt={fest.name}
              />
              <p>{fest.name}</p>
            </div>
          ))}
        </div>

        {selectedFest && (
          <div className="avatar-popup" onClick={handleClosePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <img src={selectedFest.img} alt={selectedFest.name} />
              <h3>{selectedFest.name}</h3>
              <p>{selectedFest.description}</p>
              <button className="close-btn" onClick={handleClosePopup}>&times;</button>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default TopFest;
